
import FirmwaresTable from "@/components/firmwares/FirmwaresTable.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    FirmwaresTable,
  },
})
export default class FirmwareView extends Vue {
  //
}
